/**
 * Project: fuse-react-app
 * FilePath: /src/index.js
 * File: index.js
 * Created Date: Tuesday, November 27th 2018, 7:45:42 pm
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Wed Mar 27 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import 'babel-polyfill'
import 'typeface-muli'

import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { create } from 'jss'
import jssExtend from 'jss-extend'
import JssProvider from 'react-jss/lib/JssProvider'
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles'

import registerServiceWorker from './client/registerServiceWorker'

import store from './client/store'
import api from 'client/app/services/lib/socketEngine'

import App from 'client/app.jsx'

const jss = create({
  ...jssPreset(),
  plugins: [...jssPreset().plugins, jssExtend()]
})

jss.options.insertionPoint = document.getElementById('jss-insertion-point')
const generateClassName = createGenerateClassName()

/**
 * Custom Provider to pass Websocket API down through context
 * - useful in external components so we don't have to pass via props
 */
class ApiProvider extends React.Component {
  static childContextTypes = {
    api: PropTypes.object
  }
  getChildContext () {
    return {
      api: this.props.api
    }
  }

  componentDidCatch (error, info) {
    this.setState({
      hasError: true,
      error
    })
  }

  render () {
    return this.props.children
  }
}

ReactDOM.render(
  <JssProvider jss={jss} generateClassName={generateClassName}>
    <Provider store={store}>
      <ApiProvider api={api}>
        <App />
      </ApiProvider>
    </Provider>
  </JssProvider>,
  document.getElementById('root')
)

registerServiceWorker()
